import {
  TableHead,
  TableRow,
  TableCell,
  Checkbox,
  TableSortLabel,
  Box,
} from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import { useMemo } from "react";
import { TOrder } from "../../utils";
import { IProperty } from "../../typos/properties";

export interface IEnhancedTableProps {
  numSelected: number;
  onRequestSort: (
    event: React.MouseEvent<unknown>,
    property: keyof IProperty,
  ) => void;
  onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
  order: TOrder;
  orderBy: string;
  rowCount: number;
  cells: readonly IHeadCell[];
}

export interface IHeadCell {
  disablePadding: boolean;
  id: keyof IProperty;
  label: string;
  numeric: boolean;
}

export function EnhancedTableHead(props: IEnhancedTableProps) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    cells,
  } = props;
  const createSortHandler =
    (property: keyof IProperty) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property);
    };

  const tableCellStyle = useMemo(
    () => "!text-xs whitespace-nowrap !font-bold",
    [],
  );

  return (
    <TableHead>
      <TableRow>
        <TableCell className={tableCellStyle} padding="checkbox">
          <Checkbox
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              "aria-label": "Seleccionar todas propiedades",
            }}
          />
        </TableCell>

        {cells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            className={tableCellStyle}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc"
                    ? "ordenado descendente"
                    : "ordenado ascendente"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
